import { type MetaFunction } from 'react-router'
import { pageMeta } from '#app/utils/page-meta.ts'

export const meta: MetaFunction = (args) =>
	pageMeta(args, { title: 'Personvern' })

export default function PrivacyRoute() {
	return <div>Personvern</div>
}
